import Vue from 'vue'
import Router from 'vue-router'
import home from '@/page/home'
import login from '@/page/login'
import hospManage from '@/page/hospManage'
import hospDetail from '@/page/hospDetail'
import docAdmin from '@/page/docAdmin'
import caseManage from '@/page/caseManage'
import caseDetail from '@/page/caseDetail'
import statistics from '@/page/statistics'
import regionData from '@/page/regionData'
import logUser from '@/page/logUser'
Vue.use(Router)

const routes={
  mode: 'history',
  routes:[
    {
      path:'/',
      redirect:'/login'
    },
    {
      path:'/login',
      name: 'login',
      component: login,
    },
    {
      path: '/home',
      name: 'home',
      component: home,
      children:[
        {//医院列表
          path:'/hospManage',
          name:'hospManage',
          component:hospManage
        },{//医院管理
          path:'/hospDetail',
          name:'hospDetail',
          component:hospDetail
        },{//医生管理
          path:'/docAdmin',
          name:'docAdmin',
          component:docAdmin
        },{//病例管理
          path:'/caseManage',
          name:'caseManage',
          component:caseManage
        },{//病例详情
          path:'/caseDetail',
          name:'caseDetail',
          component:caseDetail
        },{//数据统计
          path:'/statistics',
          name:'statistics',
          component:statistics
        },{
          path:'/regionData',
          name:'regionData',
          component:regionData
        },{
          path:'/logUser',
          name:'logUser',
          component:logUser
        }
      ]
    }
  ]
}
const router=new Router(routes);
router.beforeEach(function (to, from, next) {
  //跳转至上述3个页面
  if(to.path === '/login') {
    if (window.sessionStorage.getItem('userInfo')) {
      next({ name:'home'})
    }
    next()
  } 
  else {
    if(to.meta.requiresAuth && !sessionStorage.getItem('userInfo')) {
      router.push({name: 'login'})
    }else{
      next()
    }
  }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js